import React, { useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import CachedIcon from "@mui/icons-material/Cached";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";

import FrontLoginImg from "../../assets/otp.svg";

import "../../styles/Layout/_CancelApplication.scss";
// import REGEXS from "../../utils/regex";
import { generateCaptcha } from "../../utils/helpers";
import { apisPath, paths } from "../../utils/path";
import { authHttp } from "../services/utility";
// import { encrypt } from "../../utils/encryptDecrypt";
import { AuthContext } from "../../context/AuthContext";

const defaultValues = {
  otp: "",
  captcha: "",
};

const CancelApplication = () => {
  const navigate = useNavigate();
  const { state } = useLocation()
  const [securedCaptcha, setSecuredCaptcha] = useState(generateCaptcha);
  const { setAlertState, deleteAuthState, setToastState, setIsLoading } = useContext(AuthContext);

  useEffect(() => {
    if (!state?.cancel) {
      navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.dashboard}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const CancelSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(6, "Must be exactly 6 digits")
      .max(6, "Must be exactly 6 digits"),
    // otp:Yup.number()
    // .typeError("OTP must be a number")
    // .required("OTP is required")
    // .min(100000, "Must be exactly 6 digits")
    // .max(999999, "Must be exactly 6 digits"),
    captcha: Yup.string()
      .nullable()
      .required("Captcha is required")
      .oneOf([securedCaptcha], "Captcha is not correct"),
  });

  const submitHandler = async (data, { resetForm }) => {
    setIsLoading(true)
    const tempData = { ...data };
    // console.log("data :>> ", data);
    // tempData.otp = encrypt(tempData.otp);
    // console.log(typeof tempData.otp);
    authHttp
      .post(apisPath?.front?.user?.cancelApplication, {
        ...tempData,
        otp: tempData?.otp,
        captcha: tempData?.captcha,
      })
      .then((res) => {
        if (res?.data?.error) {
          setIsLoading(false)
          resetForm();
          setSecuredCaptcha(generateCaptcha);
          setAlertState((prev) => ({
            ...prev,
            open: true,
            title: res?.data?.msg,
            btnTxt: "CLOSE",
            status: "fail",
          }));
        }
        else {
          setIsLoading(false)
          setToastState((prev) => ({
            ...prev,
            open: true,
            msg: res?.data?.msg,
          }));
          authHttp.get(apisPath?.front?.user?.logout)
          setTimeout(()=>{
            deleteAuthState('app-token')
            navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.login}`)
          },1000)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
        }));
        resetForm();
        setSecuredCaptcha(generateCaptcha);
      });
  };

  return (
    <div className="cancel-application">
      <Container maxWidth={"xl"}>
        <div className="cancel-application--card">
          <Grid
            container
            spacing={6}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Box className="cancel-application--box">
                <div className="cancel-application--header">
                  <h1>Cancel Application/आवेदन रद्द करें</h1>
                </div>
                <p className="cancel-application--note">
                  <span className="text-danger">Note:-</span>
                  An OTP has been sent to your registerd Mobile Number. Please enter OTP to proceed further.
                </p>

                <div className="cancel-application--header">
                  <h4 className="cancel-application--header--h4">
                    Enter 6 digits OTP for cancel application form.
                  </h4>
                </div>
                <div className="cancel-application--form">
                  <Formik
                    initialValues={defaultValues}
                    validationSchema={CancelSchema}
                    onSubmit={submitHandler}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      setFieldValue,
                      errors,
                      touched,
                      handleBlur,
                      setFieldTouched,
                      isValid,
                      isSubmitting,
                      dirty,
                    }) => (
                      <>
                        <div className="cancel-application--field">
                          <TextField
                            autoComplete="off"
                            fullWidth
                            name="otp"
                            value={values.otp}
                            onChange={handleChange}
                            id="otp"
                            label="Enter OTP Number *"
                            variant="outlined"
                            onDrop={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onBlur={handleBlur}
                            onKeyUp={handleBlur}
                          />
                          {errors.otp && touched.otp && (
                            <p className="text-danger">{errors.otp}</p>
                          )}
                        </div>

                        <div className="cancel-application--capta">
                          <div className="cancel-application--captaheader">
                            <p>
                              Please enter the letters and numbers from the
                              image
                            </p>
                            <p>
                              (कृपया छवि से अक्षरों और संख्याओं को दर्ज करें)
                            </p>
                          </div>
                          <div className="cancel-application--captabox">
                            <div className="cancel-application--captainput">
                              <input
                                autoComplete="off"
                                type="text"
                                value={values.captcha}
                                name="captcha"
                                onChange={handleChange}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onBlur={handleBlur}
                                onKeyUp={handleBlur}
                              />
                              {errors.captcha && touched.captcha && (
                                <p className="text-danger">{errors.captcha}</p>
                              )}
                            </div>

                            <div className="cancel-application--captainfo">
                              <div className="cancel-application--captafield">
                                <span
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                >
                                  {securedCaptcha}
                                </span>
                              </div>
                              <div className="cancel-application--captaicon">
                                <CachedIcon
                                  className="cancel-application--captacachedicon"
                                  onClick={() => {
                                    setSecuredCaptcha(generateCaptcha);
                                    setFieldValue("captcha", "");
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="cancel-application--button">
                          <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!(isValid && dirty) || isSubmitting}
                          >
                            Cancel Application
                          </Button>
                          {/* <Button variant="outlined" onClick={handleSubmit}>
                            Back
                          </Button> */}
                        </div>
                      </>
                    )}
                  </Formik>
                </div>
              </Box>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <div className="cancel-application--img">
                <img src={FrontLoginImg} alt="Login" />
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default CancelApplication;
